import { useEffect, useState } from 'react';
import { useRouter, NextRouter } from 'next/router';

export type TRouteLoading = [NextRouter, boolean, (boolean) => void];

export function useRouteLoading(initialState = false): TRouteLoading {
  const router = useRouter();
  const [isLoading, setLoading] = useState(initialState);

  useEffect(() => {
    const handleStart = (url): void =>
      url !== router.pathname && setLoading(true);
    const handleComplete = (url): void =>
      url !== router.pathname && setLoading(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', (err): void => console.log(err));

    return (): void => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, []);

  return [router, isLoading, setLoading];
}
